import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { SharedModule } from '../shared-module/shared-module.module';

import { AgentBuilderListComponent } from './agent-builder-list/agent-builder-list.component';
import { AgentBuilderPromptComponent } from './agent-builder-prompt/agent-builder-prompt.component';
import { AgentBuilderConfigComponent } from './agent-builder-config/agent-builder-config.component';
import { AgentBuilderKbUploadComponent } from './agent-builder-kb-upload/agent-builder-kb-upload.component';
import { NzTabComponent, NzTabsModule } from "ng-zorro-antd/tabs";
import { NzListModule } from 'ng-zorro-antd/list';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { AgentBuilderMcpLogComponent } from './agent-builder-mcp-log/agent-builder-mcp-log.component';
import { AgentBuilderMessagesLogComponent } from './agent-builder-messages-log/agent-builder-messages-log.component';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { AgentBuilderSubagentsComponent } from './agent-builder-subagents/agent-builder-subagents.component';
import { AgentBuilderMessagesLogDetailComponent } from './agent-builder-messages-log-detail/agent-builder-messages-log-detail.component';
import { AgentBuilderMessagesLogDetailExpandableComponent } from './agent-builder-messages-log-detail/agent-builder-messages-log-detail-expandable/agent-builder-messages-log-detail-expandable.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { AgentBuilderDatabaseComponent } from './agent-builder-database/agent-builder-database.component';
import { NzCronExpressionModule } from 'ng-zorro-antd/cron-expression';
import { NzSpaceModule } from 'ng-zorro-antd/space';

@NgModule({
  declarations: [
    AgentBuilderListComponent,
    AgentBuilderConfigComponent,
    AgentBuilderPromptComponent,
    AgentBuilderKbUploadComponent,
    AgentBuilderMcpLogComponent,
    AgentBuilderMessagesLogComponent,
    AgentBuilderSubagentsComponent,
    AgentBuilderMessagesLogDetailComponent,
    AgentBuilderMessagesLogDetailExpandableComponent,
    AgentBuilderDatabaseComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NzCardModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule,
    NzUploadModule,
    NzDividerModule,
    NzIconModule,
    NzGridModule,
    NzTableModule,
    NzModalModule,
    NzAlertModule,
    NzEmptyModule,
    NzPaginationModule,
    NzTagModule,
    NzTabsModule,
    NzListModule,
    NzCollapseModule,
    NzDatePickerModule,
    NzTimelineModule,
    NzSpinModule,
    NzAvatarModule,
    NzCronExpressionModule,
    NzSpaceModule
    
],
  exports: [
    AgentBuilderListComponent,
    AgentBuilderConfigComponent,
    AgentBuilderPromptComponent,
    AgentBuilderKbUploadComponent,
    RouterModule    
  ]
})
export class AgentBuilderModule {}
